var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-task-list-wrapper",
    {
      attrs: {
        folder: _vm.folderUser.Folder,
        "can-edit": _vm.canEdit,
        "show-completed": _vm.state.showCompletedTasks,
      },
      on: {
        "toggle-completed": function ($event) {
          return _vm.toggleCompleted()
        },
        "add-item": function ($event) {
          return _vm.addItem()
        },
        "add-repeated": function ($event) {
          return _vm.addRepeated()
        },
      },
    },
    [
      _c(
        "w-row",
        { staticClass: "visible-overflow" },
        [
          _c(
            "w-col",
            { staticClass: "visible-overflow", attrs: { xs: "12" } },
            [
              _c(
                "div",
                { ref: "listRoot", staticClass: "list visible-overflow" },
                [
                  _vm.allTasks.length == 0
                    ? _c(
                        "div",
                        { key: 0, staticClass: "empty-task-list" },
                        [
                          _c("w-fa", {
                            staticClass: "mrs",
                            attrs: { icon: "check" },
                          }),
                          _vm._v(" " + _vm._s(_vm.$ct("empty-list")) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "transition-group",
                    { attrs: { name: "task-list-transition" } },
                    [
                      _vm._l(_vm.tasksBeforeDragged, function (task) {
                        return _c("app-task-item", {
                          key: task.ID,
                          ref: "beforeTasks",
                          refInFor: true,
                          attrs: { value: task, state: _vm.state },
                          on: {
                            edit: function ($event) {
                              return _vm.editTask(task)
                            },
                          },
                        })
                      }),
                      _vm.isDraggingInsideEl
                        ? _c("div", {
                            key: "splitter",
                            staticClass: "task-position-placeholder",
                            style: {
                              height: `${_vm.state.draggedTaskHeight}px`,
                            },
                          })
                        : _vm._e(),
                      _vm._l(_vm.tasksAfterDragged, function (task) {
                        return _c("app-task-item", {
                          key: task.ID,
                          ref: "afterTasks",
                          refInFor: true,
                          attrs: { value: task, state: _vm.state },
                          on: {
                            edit: function ($event) {
                              return _vm.editTask(task)
                            },
                          },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.editModal,
            callback: function ($$v) {
              _vm.editModal = $$v
            },
            expression: "editModal",
          },
        },
        [
          _vm.modalTask
            ? _c("app-task-edit-modal", {
                attrs: { folder: _vm.folderUser.Folder, state: _vm.state },
                on: {
                  close: function ($event) {
                    _vm.editModal = false
                  },
                  saved: function ($event) {
                    return _vm.refresh()
                  },
                  remove: function ($event) {
                    return _vm.removeTask(_vm.modalTask)
                  },
                },
                model: {
                  value: _vm.modalTask,
                  callback: function ($$v) {
                    _vm.modalTask = $$v
                  },
                  expression: "modalTask",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.repeatedTaskEdit
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-repeated-task-edit-modal", {
                on: {
                  close: function ($event) {
                    _vm.repeatedTaskEdit = null
                  },
                },
                model: {
                  value: _vm.repeatedTaskEdit,
                  callback: function ($$v) {
                    _vm.repeatedTaskEdit = $$v
                  },
                  expression: "repeatedTaskEdit",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }